<script lang="ts" setup>
  import type { MenuItem } from 'primevue/menuitem'
  import type { EffortHistoryEntry } from '@/services/EffortHistoryService.ts'
  import { useEffortHistoryService } from '@/services/EffortHistoryService.ts'
  import { OrderIcon, PartnerIcon, ServiceCallIcon } from '@/config/icons.ts'
  import { Router } from '@/helpers/router.ts'

  const historyService = useEffortHistoryService()
  type MenuItemEx = Omit<MenuItem, 'icon' | 'item'> & { icon?: AllIconsType; items?: MenuItemEx[] | undefined }
  const itemsInner = ref<MenuItemEx[]>([])

  watch(
    historyService.items,
    (data) => {
      console.log('update triggered')
      itemsInner.value = data.map((item: EffortHistoryEntry) => {
        const i: MenuItemEx = {
          label: item.title,
          icon: item.type == 'SERVICECALL' ? 'ServiceCallIcon' : item.type == 'ORDER' ? 'OrderIcon' : item.type == 'PARTNERCOLLECTOR' ? 'PartnerIcon' : undefined,
          key: item.id,
          command: () => {
            Router.push({ name: 'effort_details', params: { id: item.id } })
          }
        }
        return i
      })
    },
    { immediate: true }
  )
  const items = readonly(itemsInner) as Ref<MenuItem[]>

  // interface ItemTemplateObj {
  //   item: MenuItemEx
  //   props: MenubarRouterBindProps
  //   hasSubmenu: boolean
  //   root: boolean
  // }
  const onDeleteItemClick = (item: MenuItem) => {
    historyService.remove(item.key as unknown as number)
  }
</script>

<template>
  <div
    v-if="items"
    class="hidden md:block w-full border-b border-gray-200 bg-white dark:bg-black dark:border-gray-800">
    <div>
      <!--            {{historyService.items}}-->
      <Menubar
        :model="items"
        :pt="{
          root: { class: 'py-0' }
        }"
        class="w-full bg-white"
        breakpoint="100%">
        <template #item="itm">
          <div
            class="group duration-200 text-sm flex items-center cursor-pointer border rounded-full border-gray-200 px-1 py-0.5 max-w-[180px] hover:max-w-[204px]"
            @click="itm.item?.command()!">
            <component
              class="mr-1 shrink-0"
              v-if="itm.item.icon"
              :is="itm.item.icon as AllIconsType" />
            <span class="overflow-hidden text-ellipsis whitespace-nowrap group-hover:max-w-[145px]">{{ itm.item.label }}</span>

            <span class="group-hover:ml-1 overflow-hidden transition-all duration-300 ease-out max-w-0 group-hover:max-w-[24px]"
                  @click.stop="onDeleteItemClick(itm.item)">
              <component
                is="DeleteIcon"
                class="text-red-500 opacity-0 translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0"
              />
            </span>
          </div>
        </template>
      </Menubar>
    </div>
  </div>
</template>

<style scoped></style>
